import type { DiagnosticResult } from '@shared/prospect-diagnostic';
import { DiagnosticAims } from '@/components/diagnostic/DiagnosticAims';

/** Other apps built with clients, the same for every prospect (fixed list, 28/10). */
const MORE_APPS = [
  { name: 'Revue des appels de l’équipe', what: 'Chaque appel noté sur votre grille, les points à travailler par personne.' },
  { name: 'Relance des devis sans réponse', what: 'Les devis qui dorment et la bonne relance pour chacun.' },
  { name: 'Préparation d’un salon', what: 'Les visiteurs et exposants à rencontrer, les rendez-vous à caler avant.' },
  { name: 'Nouveaux décideurs chez vos clients', what: 'Qui a changé de poste, et à qui se présenter.' },
  { name: 'Point mensuel avec chaque client', what: 'Ce qui a été fait, les chiffres, la suite à proposer.' },
  { name: 'CRM propre chaque semaine', what: 'Les doublons, les affaires sans date, les contacts partis.' },
] as const;

/** Asked by Benoit (28/10): the reader must see this is a sample; lighter since 03/11, below the plan. */
const MoreToCome = () => (
  <section className="flex flex-col gap-4 rounded-3xl bg-domino-sand/25 px-6 py-6 sm:px-8">
    <h2 className="text-base font-semibold text-domino-ink">Ce n’est qu’un début</h2>
    <p className="text-[15px] leading-relaxed text-domino-inkSoft">
      Ces apps partent de quelques questions. Vous pouvez en créer d’autres pour chaque rôle, gratuitement et en autonomie
      dans la Forge de Domino, ou vous faire accompagner par un analyste de chez nous. Domino propose ensuite chaque jour à
      chacun la prochaine action à faire.
    </p>
    <ul className="grid grid-cols-1 gap-x-8 gap-y-2.5 sm:grid-cols-2">
      {MORE_APPS.map((app) => (
        <li key={app.name} className="flex flex-col gap-0.5">
          <span className="text-[14px] font-semibold text-domino-ink">{app.name}</span>
          <span className="text-[14px] text-domino-inkSoft">{app.what}</span>
        </li>
      ))}
    </ul>
    <p className="text-[15px] font-semibold text-domino-aubergine">
      Le futur de la vente et des logiciels, c’est le sur-mesure : des outils construits pour votre façon de vendre.
    </p>
  </section>
);

/**
 * The result: one summary, then one block per aim with its apps, then what comes next. Their own words
 * (objectives, problem) are no longer repeated on top: always disappointing (Benoit, 03/11).
 */
export const DiagnosticResultView = ({ result }: { result: DiagnosticResult }) => (
  <div className="flex flex-col gap-8">
    <h1 className="font-display text-3xl font-semibold leading-tight tracking-tight text-domino-aubergine md:text-4xl">
      Le potentiel de votre équipe avec Domino
    </h1>
    {result.summary && <p className="text-lg leading-relaxed">{result.summary}</p>}
    <DiagnosticAims result={result} />
    <MoreToCome />
  </div>
);
